// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ud","content":"vd","crumbsList":"wd","dropdownsWrap":"xd"};